import { Route, Routes, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import BurnInfo from "./containers/BurnInfo";
import FuelLoading from "./containers/FuelLoading";
import Home from "./containers/Home";
import PlannedBurns from "./containers/PlannedBurns";
import Review from "./containers/Review";
import SelectLocation from "./containers/SelectLocation";
import SmokeSensitiveAreas from "./containers/SmokeSensitiveAreas";
import SubmitSuccess from "./containers/SubmitSuccess";

export const appRoutes = {
	Home: '/',
	BurnInfo: '/info',
	SelectLocation: '/select-location',
	FuelLoading: '/fuel',
	SmokeSensitiveAreas: '/identify-ssa',
	PlannedBurns: '/planned-burns',
	Review: '/review',
	SubmitSuccess: '/submit-success',
}

const AppRoutes = () => {
	const location = useLocation();

	return (
		// <TransitionGroup component={null}>
		// 	<CSSTransition key={location.key} classNames="route-wrapper" timeout={3000}>
				<Routes>
					<Route exact path={appRoutes.Home} element={<Home />} />
					<Route exact path={appRoutes.SelectLocation} element={<SelectLocation />} />
					<Route exact path={appRoutes.FuelLoading} element={<FuelLoading />} />
					<Route exact path={appRoutes.SmokeSensitiveAreas} element={<SmokeSensitiveAreas />} />
					<Route exact path={appRoutes.PlannedBurns} element={<PlannedBurns />} />
					<Route exact path={appRoutes.BurnInfo} element={<BurnInfo />} />
					<Route exact path={appRoutes.Review} element={<Review />} />
					<Route exact path={appRoutes.SubmitSuccess} element={<SubmitSuccess />} />
				</Routes>
		// 	</CSSTransition>
		// </TransitionGroup>
	)
}

export default AppRoutes;